import { ItActivity } from "./it-activity.model";
import { ItProjectEstimate } from "./it-project-estimate.model";

export class ItProject {
  projectID: string;
  projectClass: string;
  projectType: string;
  businessUnit: string;
  operatingUnit: string;
  projectChargeIndicator: string;
  assetLocation: string;
  assetLocationId: string;
  majorLocation: string;
  majorLocationId: string;
  itProjectEstimates: ItProjectEstimate[];
  activities: ItActivity[];
  totalProjectCost?: number;
  groupedEstimates?: {
    majorLocation: string;
    assetLocation: string;
    locationCost: number;
    values: ItProjectEstimate[];
  }[];
  setId: string;
  hardwareOrSoftware: string;
  lateWaitPeriod: number;
  fundingProjectID: string;
  fundingProjectPercent: number;
  function: string;

  constructor(
    projectID?: string,
    businessUnit?: string,
    hardwareOrSoftware?: string,
    operatingUnit?: string,
    fundingProjectID?: string,
    fundingProjectPercent?: number
  ) {
    this.projectID = projectID;
    this.businessUnit = businessUnit;
    this.activities = [];
    this.hardwareOrSoftware = hardwareOrSoftware;
    this.operatingUnit = operatingUnit;
    this.fundingProjectID = fundingProjectID;
    this.fundingProjectPercent = fundingProjectPercent;
  }
}